<template>
  <div>
    <v-divider />

    <div class="bg-super-light-blue px-4 pt-6">
      <h4
        class="fs-18 mb-3"
        tabindex="0"
      >
        {{ $bct(subsidyProgram.staff_provider_subtitle) }}
      </h4>
      <!-- eslint-disable-next-line prefer-standard-components/no-vuetify-inputs -- TODO migrate to LabeledSelect -->
      <v-select
        v-model="providerIds"
        v-model:menu="menu"
        ref="staffSelect"
        :aria-label="ariaLabel"
        :items="providers"
        :label="$bct(placeholderValue)"
        class="b-radius-0"
        item-title="name"
        item-value="id"
        variant="solo"
        clearable
        multiple
      >
        <template #prepend-item>
          <v-list-item
            @click="handleNAChange"
            :title="$bct(LABELS.NOT_APPLICABLE)"
          >
            <template #prepend>
              <v-checkbox
                :model-value="na"
                class="mt-0 pt-0"
                color="primary"
                density="compact"
                false-icon="check_box_outline_blank"
                true-icon="check_box"
                hide-details
              />
            </template>
          </v-list-item>

          <v-divider class="mt-2" />
        </template>
      </v-select>
    </div>

    <v-divider />

    <v-row class="my-4 px-4">
      <v-col>
        <v-btn
          @click="$emit('back')"
          class="focus-very-visible"
          color="primary"
          prepend-icon="west"
          size="x-large"
          variant="outlined"
        >
          {{ $bct('Previous section') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { LABELS } from '@/shared/assets/constants';

const $bct = inject('translator');

const props = defineProps({
  providers: {
    type: Array,
    default: null,
  },
  subsidyProgram: {
    type: Object,
    default: null,
  },
  na: Boolean,
});

const emit = defineEmits(['back', 'change', 'na']);

const providerIds = defineModel({ type: Array, default: [] });

const menu = ref(false);
const staffSelect = ref(null);

const ariaLabel = computed(() => {
  const listProviders = props.providers.filter((provider) =>
    providerIds.value.includes(provider.id),
  );

  if (listProviders) return `${$bct('Select')} ${listProviders.map((lp) => lp.name).join(', ')}`;

  return `${$bct('There are no providers; please contact an admin')}`;
});

const placeholderValue = computed(() => {
  return props.na === true ? LABELS.NOT_APPLICABLE : 'Selection required';
});

function handleNAChange() {
  emit('na');
  menu.value = false;
  staffSelect.value.blur();
}
</script>

<style>
.mr-2 {
  margin-right: 8px;
}
</style>
